import { get, post, put, del } from 'services/client';
import { apiEndpoints } from 'config';

const getCampaigns = params => get({ url: apiEndpoints.campaigns, params });
const getCampaign = id => get({ url: apiEndpoints.campaign.replace(':id', id) });
const create = data => post({ url: apiEndpoints.campaigns, data });
const update = (id, data) => put({ url: apiEndpoints.campaign.replace(':id', id), data });
const duplicate = id => post({ url: apiEndpoints.campaignDuplicate.replace(':id', id) });
const remove = id => del({ url: apiEndpoints.campaign.replace(':id', id) });
const recipientsCount = data => post({ url: apiEndpoints.campaignRecipientsCount, data });
const getPartnersFilters = params => get({ url: apiEndpoints.campaignFiltersPartners, params });
const sendCampaign = id => post({ url: apiEndpoints.campaignSend.replace(':id', id) });
const getCreateAbility = (params = {}) => get({ url: apiEndpoints.campaignCreateAbility, params });

export default {
  getCampaigns,
  getCampaign,
  create,
  update,
  duplicate,
  remove,
  recipientsCount,
  getPartnersFilters,
  sendCampaign,
  getCreateAbility,
};
